export const DEFAULT_WALLET_INJECTION_ERROR = 'Failed to connect to wallet';
